import * as keys from '@/utils/storage-keys.js'

import md5 from 'js-md5'
import api from '@/api/api'
import WxNotificationCenter from '@/utils/WxNotificationCenter.js'
import { removeOssToken } from '@/utils/cookie'
// import router from '@/router/index.js'

// 只阻止比已应用成功响应更旧的快照，后发请求失败时仍允许此前请求成功更新。
let pendingTaskRequestId = 0
let lastAppliedPendingTaskRequestId = 0

const user = {
  namespaced: true,

  state: {
    info: JSON.parse(sessionStorage.getItem(keys.user.infoKey) || '{}'),
    parks: [],
    selectedParkGateId: sessionStorage.getItem(keys.user.selectedParkGateId),
    currentGate: JSON.parse(sessionStorage.getItem(keys.user.currentGate)),
    currentPark: JSON.parse(sessionStorage.getItem(keys.user.currentPark)),
    currentTask: JSON.parse(sessionStorage.getItem(keys.user.currentTask)),
    pendingTasks: [],

    token: sessionStorage.getItem('token'),
    userId: sessionStorage.getItem('userId'),
    name: sessionStorage.getItem('name'),
    authorities: sessionStorage.getItem('authorities'),
    state: sessionStorage.getItem('user_state') || 0,
    tipsPlayerInterval: null,
    tipsAudio: new Audio('./static/tts.mp3')
  },

  mutations: {
    initInfo: (state, info) => { // 登录之后不变
      state.info = info; sessionStorage.setItem(keys.user.infoKey, JSON.stringify(info))
      state.userId = info.userId; sessionStorage.setItem('userId', info.userId)
      state.name = info.name; sessionStorage.setItem('name', info.name)
      state.authorities = info.authorities; sessionStorage.setItem('authorities', info.authorities)
      state.loginTime = info.loginTime; sessionStorage.setItem('loginTime', info.loginTime)
      state.token = info.token; sessionStorage.setItem('token', info.token)
    },
    setSelectedParkGateId(state, value) {
      state.selectedParkGateId = value
      sessionStorage.setItem(keys.user.selectedParkGateId, value)
    },
    setCurrentGate(state, value) {
      state.currentGate = value
      sessionStorage.setItem(keys.user.currentGate, JSON.stringify(value))
    },
    setCurrentPark(state, value) {
      state.currentPark = value
      sessionStorage.setItem(keys.user.currentPark, JSON.stringify(value))
    },
    setCurrentTask(state, value) {
      state.currentTask = value
      sessionStorage.setItem(keys.user.currentTask, JSON.stringify(value))
    },
    setParks: (state, parks) => {
      state.parks = parks
    },
    setPendingTasks: (state, value) => {
      state.pendingTasks = value
    },
    clearInfo: (state) => { // 登录之后不变
      state.userId = ''
      state.name = ''
      state.token = ''
      sessionStorage.clear()
    },
    setState: (state, _state) => {
      state.state = _state
      sessionStorage.setItem('user_state', _state)
    },
    setTipsPlayerInterval: (state, interval) => {
      state.tipsPlayerInterval = interval
    }
  },

  actions: {
    changeCurrentTask({ commit, state }, task) {
      commit('setCurrentTask', task)

      if (!task) {
        return
      }

      for (const park of state.parks) {
        const gate = park.gates.find(g => g.id == task.gateId)
        if (gate) {
          commit('setSelectedParkGateId', gate.id)
          commit('setCurrentGate', gate)
          commit('setCurrentPark', park)
          break
        }
      }
    },
    onSelectParkOrGate({ commit, state }, selectedItem) {
      console.debug('user/onSelectParkOrGate', selectedItem)

      const currentGate = (selectedItem.level == 2) ? selectedItem : null

      const currentPark = (selectedItem.level == 1)
        ? selectedItem
        : state.parks.find(p => p.gates.some(g => g.id == selectedItem.id))

      commit('setSelectedParkGateId', selectedItem.id)
      commit('setCurrentGate', currentGate)
      commit('setCurrentPark', currentPark)

      WxNotificationCenter.postNotificationName('notification_parkGateSelected', selectedItem)
    },
    changeParkAndGate({ commit, state }, query) {
      console.debug('user/changeParkAndGate', query)

      const currentPark = state.parks.find(p => p.id == query.parkingId);
      const currentGate = currentPark.gates.find(g => g.id == query.gateId);

      commit('setSelectedParkGateId', query.gateId)
      commit('setCurrentGate', currentGate)
      commit('setCurrentPark', currentPark)
      WxNotificationCenter.postNotificationName('notification_parkGateChanged', currentGate)
    },
    // 登录
    MD5Login({ commit }, userInfo) {
      const form = {
        username: userInfo.username,
        password: userInfo.password,
        accessToken: userInfo.accessToken
      }
      return new Promise((resolve, reject) => {
        api.login(form).then(response => {
          const data = response.data

          commit('initInfo', data)
          commit('setState', 3)

          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    BSCloudlogin({ commit }, token) {
      const form = { token: token }
      return new Promise((resolve, reject) => {
        api.bscloudlogin(form).then(response => {
          const data = response.data

          commit('initInfo', data)
          commit('setState', 3)

          resolve(data.token)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登录
    Login({ dispatch }, userInfo) {
      return dispatch('MD5Login', {
        username: userInfo.username,
        password: md5(userInfo.password)
      })
    },
    // 确定登录
    FedLogIn() {
      return new Promise((resolve, reject) => {
        api.loginConfirm().then(response => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        api.logout(state.token).then(() => {
          removeOssToken();
          commit('clearInfo')
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    CheckPendingTask({ commit, dispatch, state }) {
      const requestId = ++pendingTaskRequestId
      const token = state.token
      const userId = state.userId
      return api.currentUserFecth().then((response) => {
        // 登出/重新登录后的旧响应，以及晚到的旧快照，不能覆盖当前任务列表。
        if (state.token !== token || state.userId !== userId ||
          requestId <= lastAppliedPendingTaskRequestId) return response

        const tasks = response && response.data
        if (!Array.isArray(tasks)) {
          throw new TypeError('待处理任务接口返回的数据不是数组')
        }
        tasks.forEach(item => {
          item.time = ''
        })
        lastAppliedPendingTaskRequestId = requestId
        commit('setPendingTasks', tasks)
        if (tasks.length > 0) {
          dispatch('PlayTipsMusic')
        } else {
          dispatch('StopTipsMusic')
        }
        return response
      })
    },
    PlayTipsMusic({ commit, state }) {
      if (state.state != 3) return
      if (state.tipsPlayerInterval) return
      if (state.currentTask) return

      const audio = state.tipsAudio
      audio.play()
      const t = setInterval(() => {
        audio.play()
      }, 3000)
      commit('setTipsPlayerInterval', t)
    },
    StopTipsMusic({ commit, state }) {
      const t = state.tipsPlayerInterval
      if (!t) return

      clearInterval(t)
      commit('setTipsPlayerInterval', null)
    }

  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js